import { render, staticRenderFns } from "./ViewLedger.vue?vue&type=template&id=b9447e7a"
import script from "./ViewLedger.vue?vue&type=script&lang=js"
export * from "./ViewLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports